<template>
  <a
    role="button"
    class="inline-block text-blue-600 focus:text-blue-600 hover:text-blue-600 font-medium whitespace-nowrap text-sm border rounded px-4 py-1.5 hover:border-blue-600"
    @click="impersonate"
    >Impersonate</a
  >
</template>

<script>
import { ApiClient } from '@/api/client';

const api = new ApiClient('/');

export default {
  props: {
    membership: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async impersonate() {
      try {
        await api.post(`/impersonate/${this.membership.user_id}`);

        window.location.replace('/');
      } catch (error) {
        //
      }
    },
  },
};
</script>
